import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { Col, Row, Label, CardBody } from 'reactstrap';
import { api } from '../../../config';
import { formatNumber } from '../../../utils/numberformatter';

const QuantityTableFragment = forwardRef(
  ({ dataid, token, unitSizeType }, ref) => {
    const [qtyDeliveryDataQuantity, setQtyDeliveryDataQuantity] = useState({
      items: [],
    });

    const fetchDeliveryDataDetailQuantity = useCallback(
      async (id = dataid) => {
        if (!id || !token) {
          return;
        }

        try {
          const response = await fetch(
            `${api.API_URL}/quantity-information?QuantityDeliveryTermId=${id}&SortBy=Quantity&IsDescending=false`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          const items = result.data.items.map(item => ({
            quantityDeliveryTermId: item.quantityDeliveryTermId,
            quantity: item.quantity,
            quantityIncotermId: item.quantityIncotermId,
            id:
              item.quantityDeliveryTermId ||
              Math.random().toString(36).substr(2, 9), // fallback ID
          }));

          setQtyDeliveryDataQuantity({ items });
        } catch (error) {
          // Handle error silently or add logging as needed
        }
      },
      [dataid, token]
    );

    // Expose refresh function to parent
    useImperativeHandle(ref, () => ({
      refresh: newId => fetchDeliveryDataDetailQuantity(newId),
    }));

    useEffect(() => {
      fetchDeliveryDataDetailQuantity();
    }, [fetchDeliveryDataDetailQuantity]);

    return (
      <Col lg={2}>
        <Label for='quantityreadonly' className='form-label'>
          Quantity
        </Label>
        <Row>
          <Col sm={12}>
            <div className='mb-2'>
              <CardBody>
                {/* {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger">{error}</div>
                ) : ( */}
                <div className='table-card'>
                  <table className='table table-centered align-middle table-nowrap'>
                    <thead className='table-light'>
                      <tr>
                        <th scope='col' width='100%' className=' py-1'>
                          {unitSizeType}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {qtyDeliveryDataQuantity.items.length > 0 ? (
                        qtyDeliveryDataQuantity.items.map((data, index) => (
                          <tr key={`${data.id}-${index}`}>
                            <td className='py-1'>
                              {formatNumber(data.quantity)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan='1' className='text-center py-1'>
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* )} */}
              </CardBody>
            </div>
          </Col>
        </Row>
      </Col>
    );
  }
);

QuantityTableFragment.displayName = 'QuantityTableFragment';

export default QuantityTableFragment;
